import helper from '@/utils/gridFieldsHelper';

export class CeramicFilterPara {
    constructor({
          id= null,
          recTime= '',
          locName= '',
          locId= ``,
          current= ``,
          grindingVol= ``,
          waterSupply= ``,
          concentration= ``,
          granularity= ``,
          steelBall= ``,
          filterCakeWater1= '',
          filterCakeWater2= '',
          filterCakeWater3= '',
          filterCakeWater4= '',
          filterCakeWater301= ``, 
          slurryFixedCarbon= ``,
          pulpCaContent= ``,
          stronglyMixedWater= ``,
          rawBallCarbon= ``,
          rawBallDropStrength= ``,
          ripeBallStrength= ``,
          conversionIndex= ``,
          abrasionIndex= ``,
          so2= ``,
          nox= ``,
          pm= ``,
    }={}){
        this.id = id;
        this.recTime = recTime;
        this.locName = locName;
        this.locId = locId;
        this.current = current;
        this.grindingVol = grindingVol;
        this.waterSupply = waterSupply;
        this.concentration = concentration;
        this.granularity = granularity;
        this.steelBall = steelBall;
        this.filterCakeWater301 = filterCakeWater301;
        this.filterCakeWater1 = filterCakeWater1;
        this.filterCakeWater2 = filterCakeWater2;
        this.filterCakeWater3 = filterCakeWater3;
        this.filterCakeWater4 = filterCakeWater4;
        this.slurryFixedCarbon = slurryFixedCarbon;
        this.pulpCaContent = pulpCaContent;
        this.stronglyMixedWater = stronglyMixedWater;
        this.rawBallCarbon = rawBallCarbon;
        this.rawBallDropStrength = rawBallDropStrength;
        this.ripeBallStrength = ripeBallStrength;
        this.conversionIndex = conversionIndex;
        this.abrasionIndex = abrasionIndex;
        this.so2 = so2;
        this.nox = nox;
        this.pm = pm;
    }
}

export function gridFields() {
  return Object.freeze ([
    {
        key: 'recTime',
        label: 'lbl.basic.datetime',
        sortable: true,
        form: {
            type: 'datetimepicker',
        }
    },
    {
        key: 'locName',
        label: 'lbl.cfp.pelletizing',
        sortable: true,
        form: {
            type: 'input',
        },
        callback: {
            check:helper.checkNotEmpty,
        }
    },
    {
        key: 'current',
        label: 'lbl.cfp.current',
        sortable: true,
        form: {
            type: 'input',
        },
        callback: {
            check:helper.checkNotEmpty,
        }
    },
    {
        key: 'grindingVol',
        label: 'lbl.cfp.grindingVol',
        sortable: true,
        form: {
            type: 'input',
        },
        callback: {
            check:helper.checkNotEmpty,
        }
    },
    {
        key: 'waterSupply',
        label: 'lbl.cfp.waterSupply',
        sortable: true,
        form: {
            type: 'input',
        },
        callback: {
            check:helper.checkNotEmpty,
        }
    },
    {
        key: 'concentration',
        label: 'lbl.cfp.concentration',
        sortable: true,
        form: {
            type: 'input',
        },
        callback: {
            check:helper.checkNotEmpty,
        }
    },
    {
        key: 'granularity',
        label: 'lbl.cfp.granularity',
        sortable: true,
        form: {
            type: 'input',
        },
        callback: {
            check:helper.checkNotEmpty,
        }
    },
    {
        key: 'steelBall',
        label: 'lbl.cfp.steelBall',
        sortable: true,
        form: {
            type: 'input',
        },
        callback: {
            check:helper.checkNotEmpty,
        }
    },
    {
        key: 'filterCakeWater1',
        label: 'lbl.cfp.filterCakeWater1',
        form: {
            type: 'input',
        },
        callback: {
            check:helper.checkNotEmpty,
        }
    },
    {
        key: 'filterCakeWater2',
        label: 'lbl.cfp.filterCakeWater2',
        form: {
            type: 'input',
        },
        callback: {
            check:helper.checkNotEmpty,
        }
    },
    {
        key: 'filterCakeWater3',
        label: 'lbl.cfp.filterCakeWater3',
        form: {
            type: 'input',
        },
        callback: {
            check:helper.checkNotEmpty,
        }
    },
    {
        key: 'filterCakeWater4',
        label: 'lbl.cfp.filterCakeWater4',
        form: {
            type: 'input',
        },
        callback: {
            check:helper.checkNotEmpty,
        }
    },
    {
        key: 'filterCakeWater301',
        label: 'lbl.cfp.filterCakeWater301',
        sortable: true,
        form: {
            type: 'input',
        },
        callback: {
            check:helper.checkNotEmpty,
        }
    },
    {
        key: 'slurryFixedCarbon',
        label: 'lbl.cfp.slurryFixedCarbon',
        sortable: true,
        form: {
            type: 'input',
        },
        callback: {
            check:helper.checkNotEmpty,
        }
    },
    {
        key: 'pulpCaContent',
        label: 'lbl.cfp.pulpCaContent',
        sortable: true,
        form: {
            type: 'input',
        },
        callback: {
            check:helper.checkNotEmpty,
        }
    },
    {
        key: 'stronglyMixedWater',
        label: 'lbl.cfp.stronglyMixedWater',
        sortable: true,
        form: {
            type: 'input',
        },
        callback: {
            check:helper.checkNotEmpty,
        }
    },
    {
        key: 'rawBallCarbon',
        label: 'lbl.cfp.rawBallCarbon',
        sortable: true,
        form: {
            type: 'input',
        },
        callback: {
            check:helper.checkNotEmpty,
        }
    },
    {
        key: 'rawBallDropStrength',
        label: 'lbl.cfp.rawBallDropStrength',
        sortable: true,
        form: {
            type: 'input',
        },
        callback: {
            check:helper.checkNotEmpty,
        }
    },
    {
        key: 'ripeBallStrength',
        label: 'lbl.cfp.ripeBallStrength',
        sortable: true,
        form: {
            type: 'input',
        },
        callback: {
            check:helper.checkNotEmpty,
        }
    },
    {
        key: 'conversionIndex',
        label: 'lbl.cfp.conversionIndex',
        sortable: true,
        form: {
            type: 'input',
        },
        callback: {
            check:helper.checkNotEmpty,
        }
    },
    {
        key: 'abrasionIndex',
        label: 'lbl.cfp.abrasionIndex',
        sortable: true,
        form: {
            type: 'input',
        },
        callback: {
            check:helper.checkNotEmpty,
        }
    },
    {
        key: 'so2',
        label: 'lbl.cfp.so2',
        sortable: true,
        form: {
            type: 'input',
        },
        callback: {
            check:helper.checkNotEmpty,
        }
    },
    {
        key: 'nox',
        label: 'lbl.cfp.nox',
        sortable: true,
        form: {
            type: 'input',
        },
        callback: {
            check:helper.checkNotEmpty,
        }
    },
    {
        key: 'pm',
        label: 'lbl.cfp.pm',
        sortable: true,
        form: {
            type: 'input',
        },
        callback: {
            check:helper.checkNotEmpty,
        }
    },
  ]);  
}

export const fields = Object.freeze(Object.keys(new CeramicFilterPara()).map(i => 'entity.' + i));

export const filterFields = [
    'filter.startTimeFilter',
    'filter.endTimeFilter',
    'filter.locNameFilter',
];

export const filter = {
    'startTimeFilter':"",
    'endTimeFilter':"",
    'locNameFilter':"default",
};